export const SUGGESTED_SCHOOL_ID = -1

export const PBSLM_TITLE = "PBS LearningMedia"

export const ORDERED_GRADE_KEYS = [
    "PreK",
    "K",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13+",
]

export const ORDERED_MEDIA_TYPES = [
    "Collection",
    "Video",
    "Interactive Lesson",
    "Interactive",
    "Lesson Plan",
    "Media Gallery",
    "Audio",
    "Image",
    "Document",
    "Webpage",
]

export const ALIASED_FACETS = ["cp", "cs", "ct", "subject"]

export const CH_FACET_ID = "ch"
